<template>
  <section class="seller-steps-section">
    <div class="container">
      <div class="seller-row">
        <div class="seller-steps">
          <h2>Как это работает?</h2>
          <p class="seller-steps__subtitle">
            Сделай всего <strong>3</strong> простых шага
          </p>
        </div>
        <div class="steps-grid">
          <div class="step" v-for="(step, index) in steps" :key="index">
            <div class="circle">{{ index + 1 }}</div>
            <div>
              <p>
                <strong>{{ step.title }}</strong>
              </p>
              <small>{{ step.subtitle }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const steps = [
  {
    title: "Зарегистрируйтесь и укажите ИНН",
    subtitle: 'Получите бейдж "Проверенный продавец"',
  },
  {
    title: "Создайте витрину",
    subtitle: "Загрузите товары / услуги, укажите цены",
  },
  {
    title: "Получайте заказы",
    subtitle: "Общайтесь и заключайте сделки прямо на платформе",
  },
];
</script>

<style scoped lang="scss">
.container {
  max-width: 1200px;
  margin: 0 auto;
}

.seller-steps-section {
  background-image: url("../../assets/images/background-sellers.png");
  padding: 64px 20px;
  color: white;
}
h2 {
  font-size: 45px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
}
.seller-steps__subtitle {
  margin: 30px 0;
  font-size: 30px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
}
.seller-row {
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}
.steps-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.step {
  display: flex;
  align-items: flex-start;
  background: white;
  color: rgba(62, 62, 62, 1);
  border-radius: 30px;
  padding: 20px;
  gap: 16px;
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
  font-size: 20px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
}
p {
  margin-bottom: 8px;
}
.circle {
  width: 60px;
  height: 60px;
  background-color: rgba(236, 237, 239, 1);
  color: white;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: rgba(0, 199, 130, 1);
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 24px;
  }
}
</style>
